var _g, _g2, _g3, _g4, _path, _g5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTop3Big = function SvgTop3Big(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top3_big_svg__0zttlitj0a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.545 6.977h-.131c-4.215 0-7.634-.22-7.634 3.921 0 4.14 3.419 11.077 7.634 11.077h.131c1.495 0 2.704-1.189 2.704-2.657V9.633c0-1.465-1.21-2.656-2.704-2.656zm32.6 0h-.13c-1.495 0-2.705 1.188-2.705 2.656v9.682c0 1.468 1.21 2.656 2.705 2.656h.13c4.216 0 7.635-6.935 7.635-11.076 0-4.138-3.416-3.918-7.634-3.918z",
    fill: "#FFCEA4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top3_big_svg__07nawy7ydb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCEA4",
    d: "M22.112 31.975h6v12h-6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top3_big_svg__hkpura26ac)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.112,
    y: 40.975,
    width: 30,
    height: 6,
    rx: 3,
    fill: "#FFCEA4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top3_big_svg__l0urapnjkd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.223 0H14.159c-3.524 0-6.38 2.602-6.38 5.812v13.144c0 8.76 7.796 15.863 17.41 15.863 9.615 0 17.41-7.103 17.41-15.863V5.81C42.6 2.602 39.744 0 36.223 0z",
    fill: "url(#Top3_big_svg__4uz7xhfsfe)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Top3_big_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.443 0H14.38C10.856 0 8 2.602 8 5.812v13.144c0 8.76 7.795 15.863 17.41 15.863 9.614 0 17.41-7.103 17.41-15.863V5.81c0-3.208-2.856-5.81-6.377-5.81z",
    fill: "url(#Top3_big_svg__fexfq4sx0f)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Top3_big_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#Top3_big_svg__o9nu0llwlh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.153 28.235C9.25 29.895 9.691 10.1 11.9-.005l19.88-1.662c-2.485 5.814-7.29 19.934-6.627 29.902z",
    fill: "#FFB98E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top3_big_svg__upy9250asi)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.46 28.588c15.543 3.76 17.735-15.92 16.888-26.23L35.866-1.928c1.69 6.093 4.576 20.727 2.595 30.517z",
    fill: "#FFB181"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top3_big_svg__nm72gi62nj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.255 31.938c-3.178 15.671 16.57 17.129 26.84 15.899l3.56-19.629c-6.026 1.916-20.542 5.345-30.4 3.73z",
    fill: "#F66700"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top3_big_svg__b20ou390ok)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.514 20.144c0-2.19-.962-3.51-2.215-4.288a.225.225 0 010-.377c1.13-.716 1.939-1.899 1.939-3.844C31.238 8.32 28.724 6 25.243 6c-3.15 0-5.677 1.896-5.991 5.096-.028.28.2.512.48.512h2.702a.439.439 0 00.42-.376c.217-1.263 1.154-2 2.39-2 1.297 0 2.402.856 2.402 2.514 0 1.381-.745 2.458-2.486 2.458h-.025a.5.5 0 00-.5.5v2.122a.5.5 0 00.5.5h.025c1.768 0 2.763 1.077 2.763 2.707 0 1.768-1.105 2.735-2.652 2.735-1.302 0-2.439-.684-2.648-2.182a.436.436 0 00-.42-.387h-2.696a.478.478 0 00-.485.508C19.31 24.454 22.203 26 25.271 26c3.37 0 6.243-1.934 6.243-5.856z",
    fill: "url(#Top3_big_svg__ybp62v2xul)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Top3_big_svg__0zttlitj0a",
    x: 0.78,
    y: 6.975,
    width: 48,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4982_277881"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top3_big_svg__07nawy7ydb",
    x: 22.112,
    y: 31.975,
    width: 6,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4982_277881"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top3_big_svg__hkpura26ac",
    x: 10.112,
    y: 40.975,
    width: 30,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4982_277881"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top3_big_svg__l0urapnjkd",
    x: 4.78,
    y: -2,
    width: 37.819,
    height: 36.819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.983333 0 0 0 0 0.177 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4982_277881"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_4982_277881",
    result: "effect2_innerShadow_4982_277881"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top3_big_svg__o9nu0llwlh",
    x: -0.22,
    y: -12.667,
    width: 43,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "effect1_foregroundBlur_4982_277881"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top3_big_svg__upy9250asi",
    x: 24.866,
    y: -12.929,
    width: 41.638,
    height: 52.988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "effect1_foregroundBlur_4982_277881"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top3_big_svg__nm72gi62nj",
    x: -0.087,
    y: 17.208,
    width: 52.741,
    height: 41.966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "effect1_foregroundBlur_4982_277881"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top3_big_svg__b20ou390ok",
    x: 17.021,
    y: 5,
    width: 16.493,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.945833 0 0 0 0 0.425625 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4982_277881"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4982_277881",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Top3_big_svg__4uz7xhfsfe",
    x1: 34.724,
    y1: 17.333,
    x2: 12.724,
    y2: 17.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Top3_big_svg__fexfq4sx0f",
    x1: 34.944,
    y1: 17.333,
    x2: 12.944,
    y2: 17.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Top3_big_svg__ybp62v2xul",
    x1: 25.257,
    y1: 6,
    x2: 25.257,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD9C4"
  })))));
};

export default SvgTop3Big;